<template>
  <el-dialog
    class="font-info-dialog global-dialog"
    :modal="false"
    width="550px"
    :visible.sync="dialogValue"
    title="字体信息"
    direction="rtl"
  >
    <div class="fid-body">
      <div class="fi-text">字体名称：{{ data.fontFamily }}</div>
      <div v-if="origin === 'project'" class="fi-text subtitle">来源：{{ data.uploadByProj ? '本地上传' : '公共字体' }}</div>
      <!-- <p class="fi-item">
        <label>上传人:</label>
        <span class="font-name c-ellipsis" v-text="data.uploadBy"></span>
      </p>
      <p class="fi-item">
        <label>别名:</label>
        <template v-if="edit">
          <el-input
            size="mini"
            v-model="data.alias"
            class="font-name"
            :maxlength="20"
          ></el-input>
          <el-button type="text" @click="onSave">保存</el-button>
        </template>
        <template v-else>
          <span v-text="data.alias" class="font-name c-ellipsis"></span>
          <el-button type="text" @click="onEdit">修改</el-button>
        </template>
      </p>
      <ul>
        <li class="fi-item">
          <label>主名:</label>
          <span class="font-name c-ellipsis" v-text="data.name"></span>
          <el-button type="text" @click="onAdd" v-if="!newNameVisible"
            >添加</el-button
          >
        </li>
        <template v-if="data.mainNames">
          <li
            class="fi-item"
            v-for="(name, idx) in filterMainNames"
            :key="`${idx}_${name}`"
          >
            <label>主名{{ idx + 1 }}:</label>
            <span class="font-name c-ellipsis" v-text="name"></span>
          </li>
        </template>
        <li class="fi-item" v-show="newNameVisible">
          <el-input
            size="mini"
            v-model="newName"
            class="font-name fn-mr"
          ></el-input>
          <el-button type="text" @click="onSaveFontName" :loading="addLoading"
            >保存</el-button
          >
        </li>
      </ul> -->
    </div>
    <div slot="footer">
      <el-button type="primary" @click="dialogValue = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import fontService from '@/request/service/font-service'
export default {
  props: {
    value: { type: Boolean, default: false },
    origin: {
      type: String,
      default: 'system'
    },
    data: {
      type: Object,
      default () {
        return { id: null, mainNames: [] }
      }
    }
  },
  data () {
    return {
      loading: false,
      edit: false,
      newNameVisible: false,
      newName: '',
      addLoading: false
    }
  },
  computed: {
    dialogValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    filterMainNames () {
      return this.data.mainNames.filter(name => {
        return name !== this.data.name
      })
    }
  },
  watch: {
    'data.id' () {
      this.clearAllData()
    }
  },
  methods: {
    onEdit () {
      this.edit = true
    },
    onSave () {
      if (this.data.alias.trim() === '') {
        this.$message.error('名称不能为空')
        return
      }
      fontService
        .updateFontAlias({ id: this.data.id, alias: this.data.alias })
        .then(() => {
          this.$message.success('更新成功')
          this.edit = false
          this.$emit('onAliasChange', JSON.parse(JSON.stringify(this.data)))
        })
    },
    onAdd (item) {
      this.newNameVisible = true
    },
    onSaveFontName () {
      let newName = this.newName
      if (newName.trim() === '') {
        this.$message.error('名称不能为空')
        return
      }
      let mainNames = [this.data.name].concat(this.data.mainNames || [])
      let hasSameName = mainNames.some(name => {
        return name === newName
      })
      if (hasSameName) {
        this.$message.error('主名已经存在')
        return
      }
      this.addLoading = true
      fontService
        .addFontName({ id: this.data.id, name: this.newName })
        .then(() => {
          this.$message.success('添加成功')
          this.data.mainNames.push(this.newName)
          this.newNameVisible = false
          this.newName = ''
          this.$emit('onMainNamesChange', JSON.parse(JSON.stringify(this.data)))
        })
        .finally(() => {
          this.addLoading = false
        })
    },
    clearAllData () {
      this.newNameVisible = false
      this.newName = ''
      this.edit = false
    }
  }
}
</script>
<style lang="scss">
@import 'font-info-dialog.scss';
</style>
